import React from 'react';
import ReactDOM from 'react-dom';
import LoanCalculator from './LoanCalculator';
import('./style.css')

document.addEventListener('DOMContentLoaded', () => {

    ReactDOM.render(<LoanCalculator dynamicPrice={window.dynamicPrice} />, document.getElementById('loanCalculator'));
});